import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
// Changelog route removed for now
import Docs from "@/pages/Docs";
import Blog from "@/pages/Blog";

import { SiteLayout } from "@/components/site/SiteLayout";
import { ThemeProvider } from "@/components/site/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <SiteLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              {/* /changelog hidden */}
              <Route path="/docs" element={<Docs />} />
              <Route path="/blog" element={<Blog />} />
            </Routes>
          </SiteLayout>
          <Toaster />
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
